import { createContext, useContext, useId } from "react";
var ServerHeadInsertions = {};
var getServerHeadInsertions = function getServerHeadInsertions2(id) {
  if (ServerHeadInsertions[id]) {
    return Object.values(ServerHeadInsertions[id]);
  }
};
var ServerRenderID = /* @__PURE__ */ createContext("");
var useServerHeadInsertion = function useServerHeadInsertion2(callback) {
  if (typeof window == "undefined") {
    var _ServerHeadInsertions, _id;
    var insertionID = useId();
    var id = useContext(ServerRenderID);
    (_ServerHeadInsertions = ServerHeadInsertions)[_id = id] || (_ServerHeadInsertions[_id] = {});
    ServerHeadInsertions[id][insertionID] = callback;
  }
};
export {
  ServerRenderID,
  getServerHeadInsertions,
  useServerHeadInsertion
};
//# sourceMappingURL=useServerHeadInsertion.js.map
